<template>
  <header class="header">
    <div class="header-inner">
      <div class="logo" @click="toggleMenu" style="cursor:pointer;display:flex;align-items:center;">
        <img src="../assets/logo.png" alt="logo" />
        <span class="logo-title">聚宝铺</span>
      </div>
      <!-- 汉堡按钮已隐藏 -->
      <!-- <button class="menu-toggle" @click="toggleMenu" aria-label="菜单" v-show="!menuOpen">
        <span class="bar"></span>
        <span class="bar"></span>
        <span class="bar"></span>
      </button> -->
      <!-- 导航菜单，PC端始终显示，移动端弹窗显示 -->
      <nav class="nav" :class="{ 'mobile-open': menuOpen }">
        <router-link to="/" @click="closeMenu">首页</router-link>
        <div class="nav-link" @click="onDocClick">产品手册</div>
        <router-link to="/pricing" @click="closeMenu">价格</router-link>
        <router-link to="/help" @click="closeMenu">帮助中心</router-link>
        <router-link to="/contact" @click="closeMenu">联系我们</router-link>
        <div class="header-btns">
          <button class="main-btn" @click="onDownloadClick">下载插件</button>
          <router-link to="/register" @click="closeMenu"><button class="ghost-btn">新用户注册</button></router-link>
        </div>
      </nav>
      <!-- 遮罩层，移动端菜单弹出时显示 -->
      <div class="menu-mask" v-if="menuOpen" @click="closeMenu"></div>
    </div>
  </header>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { checkVersion } from '../api/admin'

const router = useRouter()
const route = useRoute()

const menuOpen = ref(false)

function toggleMenu() {
  menuOpen.value = !menuOpen.value
}
function closeMenu() {
  menuOpen.value = false
}
function onDocClick() {
  window.open('https://qcn0uu72n24r.feishu.cn/wiki/OLTSwVOeLiFIL5kg64vctp4EnWl', '_blank')
}

async function onDownloadClick() {
  try {
    const res = await checkVersion('0.0.0')
    if (res.code === 200 && res.data && res.data.downPath) {
      window.location.href = res.data.downPath
    } else {
      alert(res.message || '获取下载链接失败')
    }
  } catch (e) {
    alert('网络错误，获取下载链接失败')
  }
}


</script>

<style scoped>
.header {
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 16px #4ba3fa22;
  border-radius: 0 0 24px 24px;
  position: sticky;
  top: 0;
  z-index: 100;
}
.header-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding: 0 24px;
}
.logo img {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  object-fit: contain;
  background: #eaf3fb;
}
.logo img:hover {
  filter: drop-shadow(0 0 12px #4ba3fa) drop-shadow(0 0 24px #4ba3fa88);
}
.nav {
  display: flex;
  gap: 48px;
}
.nav a, .nav .router-link-active, .nav .nav-disabled, .nav .nav-link {
  color: #222;
  font-size: 1.15rem;
  font-weight: bold;
  text-decoration: none;
  background: none;
  padding: 0 6px 0 6px;
  border-radius: 0;
  border-bottom: 3px solid transparent;
  transition: color 0.2s, border-bottom 0.2s;
  line-height: 2.2;
  cursor: pointer;
}
.nav a.router-link-exact-active, .nav a.router-link-active {
  color: #2979ff !important;
  border-bottom: 3px solid #2979ff;
  background: none;
}
/* 移除按钮区域的选中效果 */
.header-btns a.router-link-active,
.header-btns a.router-link-exact-active {
  color: inherit !important;
  border-bottom: none !important;
}
.nav a:hover, .nav .nav-link:hover {
  color: #2979ff;
}
.header-btns {
  display: flex;
  gap: 16px;
}
.main-btn {
  background: #2979ff;
  color: #fff;
  border: none;
  border-radius: 24px;
  padding: 10px 28px;
  font-size: 1.08rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 8px #2979ff22;
  transition: background 0.2s;
}
.main-btn:hover {
  background: #1656c1;
}
.ghost-btn {
  background: #fff;
  color: #2979ff;
  border: 1.5px solid #2979ff;
  border-radius: 24px;
  padding: 10px 24px;
  font-size: 1.08rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.ghost-btn:hover {
  background: #eaf3fb;
  color: #1656c1;
}

.menu-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 38px;
  height: 38px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 201;
  margin-left: 8px;
}
.menu-toggle .bar {
  width: 26px;
  height: 3px;
  background: #2979ff;
  margin: 3px 0;
  border-radius: 2px;
  transition: all 0.3s;
}
.menu-mask {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.18);
  z-index: 200;
}
.logo-title {
  font-size: 1.28rem;
  font-weight: bold;
  color: #1f242b;
  margin-left: 12px;
  letter-spacing: 2px;
  user-select: none;
}

@media (max-width: 768px) {
  .header-inner {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 8px;
    gap: 0;
    position: relative;
    width: 100%;
  }
  .logo {
    z-index: 203;
    display: flex;
    align-items: center;
    height: 56px;
  }
  .logo img {
    width: 38px;
    height: 38px;
    margin-bottom: 0;
  }
  .logo-title {
    font-size: 1.28rem;
    margin-left: 12px;
    letter-spacing: 1.5px;
  }
  .menu-toggle {
    display: none !important;
  }
  .nav {
    position: fixed;
    top: 0;
    right: 0;
    width: 80vw;
    max-width: 340px;
    height: 100vh;
    background: #fff;
    box-shadow: -4px 0 32px #4ba3fa33;
    border-radius: 0 18px 18px 0;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0;
    padding: 38px 22px 22px 22px;
    transform: translateX(100%);
    transition: transform 0.25s cubic-bezier(.4,0,.2,1);
    z-index: 202;
    opacity: 0.98;
    display: flex;
    box-sizing: border-box;
  }
  .nav.mobile-open {
    transform: translateX(0);
  }
  .nav a, .nav .router-link-active, .nav .nav-link {
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 2.4;
    padding: 8px 0 8px 2px;
    border-bottom-width: 2px;
    width: 100%;
    display: block;
    text-align: left;
    color: #2979ff;
    border-radius: 8px;
    margin-bottom: 2px;
    transition: background 0.18s, color 0.18s;
  }
  .nav a.router-link-exact-active, .nav a.router-link-active {
    color: #1656c1 !important;
    /* background: #eaf3fb; */
  }
  /* 移除新用户注册按钮的选中效果 */
  .header-btns .router-link-active {
    color: inherit !important;
    border-bottom: none !important;
  }
  .nav a:hover, .nav .nav-link:hover {
    background: #f5f7fa;
    color: #4ba3fa;
  }
  .header-btns {
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 22px;
  }
  .main-btn, .ghost-btn {
    width: 100%;
    padding: 12px 0;
    font-size: 1.08rem;
    border-radius: 18px;
    margin-bottom: 2px;
  }
  .main-btn {
    background: linear-gradient(90deg, #4ba3fa 0%, #2979ff 100%);
    color: #fff;
    font-weight: 600;
    box-shadow: 0 2px 8px #4ba3fa33;
    border: none;
  }
  .ghost-btn {
    background: #fff;
    color: #2979ff;
    border: 1.5px solid #2979ff;
    font-weight: 600;
  }
}
</style>